import XLSX from 'xlsx';
import FileSaver from 'file-saver';

export default {
    data() {
        return {
            // 搜索条件
            form: {
                // 学员姓名
                name: '',
                // 身份证号
                idcard: '',
                // 单位
                company: '',
                // 课程名称
                product_name: '',
                // 课件标题
                courseware_title: '',
                // 已学时长
                time: '',
                // 播放位置
                location: '',
                // 上次学习时间
                last_study_time: '',
                // 完成时间
                done_study_time: '',
                // 学习状态
                study_status: '',
            },
            // 学习状态
            studyState: [
                {
                    value: 2,
                    label: '已完成'
                },
                {
                    value: 1,
                    label: '学习中'
                },
                {
                    value: 0,
                    label: '未开始'
                }
            ],
            // 表格数据
            tableData: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 选择的row
            selections: [],
            // 选择的row的id
            selectionIds: [],
            // 控制显示添加对话框的变量
            addDialog: false,
            // 添加的变量
            addForm: {
                time: '',
                location: '',
                lastTime: '',
                finishTime: '',
                learningState: '',
                name: '',
                productName: '',
                title: '',
            },
            // 课程名称数组
            productNames: [],
            // 课件标题数组
            titles: [],
            // 控制显示修改对话框的变量
            editDialog: false,
            // 需要修改的记录
            record: [],
            // 某个课程的资源数组
            curriculumResourceList: [],
            // 显示加载中
            loading: false,
            // 导出显示加载中
            exportLoading: false,
            // 导出excel
            excelDialog: false,
            exceldata: {
                offset: 0,
                length: 0
            },
        }
    },

    methods: {
        search() {
            // 当前页
            this.currentPage = 1
            this.getData()
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
            if (selections.length !== 0) {
                this.selections = selections;
                this.record = selections[0]
                // 取出选择的row的id
                this.selectionIds = selections.map(item => item.purchased_id);
            }
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.getData();
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getData();
        },

        // 新增记录
        add() {
            this.addDialog = true;
        },

        // 确认添加记录
        confirmAdd() {
            // 验证数据
            // 发送请求添加
            this.addDialog = false;
        },

        // 修改记录
        edit() {
            // 先判断是否有选择学员且最多选择一名学员
            if (this.selectionIds.length === 0 || this.selectionIds.length !== 1) {
                this.$message.warning('抱歉！请选择一名学员！');
                return;
            }

            this.loading = true;

            // 显示修改对话框
            this.editDialog = true;

            // 发送请求获取该学员这门课程的详情
            // this.record是在选择表格某一行的时候赋值的，是当前选择的row对象
            this.$post('products/getCourse', {
                token: this.$store.state.authority_management,
                course_name: this.record.product_name,
                product_id: this.record.product_id,
                owner_id: this.record.owner_id,
                offset: 0,
                length: 999,
            }).then(res => {
                if (res.data.status == 'success') {
                    this.curriculumResourceList = res.data.result;
                    this.loading = false;
                }
            });

        },

        // 确定修改记录
        confirmEdit() {
            // 修改。。
            this.editDialog = false;
            this.$post('userAdmin/updateCourseWareStudyStatus', {
                purchased_id: this.record.purchased_id,
                rate: rate,
                done_study_time: this.record.done_study_time,
                last_study_time: this.record.last_study_time,
                study_status: this.record.study_status,
                product_name: this.record.product_name,
            }).then(res => {
                this.$message({
                    type: 'success',
                    message: '修改成功'
                });
                this.getData();
            })
        },

        // 删除记录
        remove() {
            // 先判断是否有选择学员
            if (this.selectionIds.length === 0) {
                this.$message.warning('抱歉！最少选择一名学员！');
                return;
            }

            // 提示
            this.$confirm('是否删除选择的记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('userAdmin/delCourseWareStudyStatus', {
                    purchasedIds: JSON.stringify(this.selectionIds)
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(err => {
                    this.$message({
                        type: 'error',
                        message: '删除失败!'
                    });
                });
                this.getData();

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        getData() {
            this.$post('userAdmin/courseWareStudyStatus', {
                token: this.$store.state.authority_management,
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize,
                name: this.form.name,
                idcard: this.form.idcard,
                company: this.form.company,
                product_name: this.form.product_name,
                study_status: this.form.study_status,
                last_study_time: this.form.last_study_time,
                done_study_time: this.form.done_study_time

            }).then(res => {
                this.tableData = res.data.result.result;
                this.total = res.data.result.total;
            })
        },

        // 导出excel
        exportExcel() {
            this.excelDialog = true;
        },

        // 确认导出
        confirmexport() {
            this.exportLoading = true;
            this.excelDialog = false;
            let data = {
                token: this.$store.state.authority_management,
                offset: this.exceldata.offset,
                length: this.exceldata.length
            }
            if (this.form.name) {
                data.name = this.form.name
            }
            if (this.form.idcard) {
                data.idcard = this.form.idcard
            }
            if (this.form.company) {
                data.company = this.form.company
            }
            if (this.form.product_name) {
                data.product_name = this.form.product_name
            }
            if (this.form.courseware_title) {
                data.courseware_title = this.form.courseware_title
            }
            if (this.form.time) {
                data.time = this.form.time
            }
            if (this.form.location) {
                data.location = this.form.location
            }
            if (this.form.last_study_time) {
                data.last_study_time = this.form.last_study_time
            }
            if (this.form.done_study_time) {
                data.done_study_time = this.form.done_study_time
            }
            if (this.form.study_status) {
                data.idcard = this.form.study_status
            }

            this.$post('userAdmin/courseWareStudyStatusExport', data).then(res => {
                this.exportLoading = false;
                window.open(res.data.result)
            })
        },

        // 在输入框输入数据时触发
        inputNumber(e) {
            e >= 20000 ? this.exceldata.length = 20000 : this.exceldata.length = e;
        },
    },
    filters: {
        studyStateFilter(value) {
            if (value == 0) {
                return '未开始'
            } else if (value == 1) {
                return '已完成'
            } else {
                return '学习中';
            }
        },
    },
    created() {
        this.getData()
    },
}